import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Card from '../components/Card'
import Switcher from '../components/Switcher'
import Paragraph from '../components/Paragraph'
import Text from "./Text";

@observer
export default class VisualFieldProgression extends Component {
  @observable scene = 'TWO'

  @action
  setScene = scene => {
    this.scene = scene
  }

  render() {
    return (
      <Card>
        <Card.Pad>
          <Switcher
            color="blue"
            choices="phoneSession"
            value={this.scene}
            onChange={this.setScene}
          />
        </Card.Pad>
        <Card.Divider />
        <Card.Pad>
          {this.scene === 'ONE' &&
            <Fragment>
              <Paragraph><b><center><Text str="prose.wentDownInAdherence"/></center></b></Paragraph>
              <Paragraph><Text str="prose.overView"/>:</Paragraph>
              <Paragraph>* <Text str="prose.warmGreeting"/></Paragraph>
              <Paragraph>* <Text str="prose.shareAdherenceData"/></Paragraph>
              <Paragraph>* <Text str="prose.reflectUntilUnderstanding" /></Paragraph>
              <Paragraph>* <Text str="prose.discussBarriers"/></Paragraph>
              <Paragraph>* <Text str="prose.editPlan"/></Paragraph>
              <Paragraph>* <Text str="prose.summarizeConversation"/></Paragraph>
              <Paragraph>* <Text str="prose.hopefulnessScale"/></Paragraph>
              <Paragraph>   </Paragraph>
              <Paragraph>   </Paragraph>
              <br />
              <Paragraph>Q: <Text str="prose.phoneScreeningOpening"/></Paragraph>
              <Paragraph>S: <Text str="prose.phoneNotGoodTime"/></Paragraph>
              <Paragraph str="prose.phoneShareData" />
              <Paragraph str="prose.phoneEyeDropBeforeAfter" />
              <Paragraph str="prose.reflectBack" />
              <Paragraph str="prose.feelLikeALot" />
              <Paragraph str="prose.whatTimeTroubleTakingEyeDrops" />
              <Paragraph str="prose.improveTiming" />
              <Paragraph str="prose.reflect" />
              <Paragraph str="prose.notConvincedMoreDrops" />
              <Paragraph str="prose.linkBetweenTimeAndVision" />
              <Paragraph str="prose.reflect" />
              <Paragraph str="prose.provideInformation" />
              <Paragraph str="prose.shareTimeAndVision" />
              <Paragraph str="prose.doseWearOff" />
              <Paragraph str="prose.betterLate" />
              <Paragraph str="prose.fitUnderstanding" />
              <Paragraph str="prose.reflectBack" />
              <Paragraph><Text str="prose.optionalReflections"/>: </Paragraph>
              <Paragraph>* <Text str="prose.comfortableWithMin"/></Paragraph>
              <Paragraph>* <Text str="prose.notFitWithLife"/></Paragraph>
              <Paragraph>* <Text str="prose.notStrongMotivation"/></Paragraph>
              <Paragraph>* <Text str="prose.moreInfoToConvince"/></Paragraph>
              <Paragraph str="prose.planToRemember"/>
              <Paragraph>R: [<Text str="prose.notLikePlan"/>]: </Paragraph>
              <Paragraph str="prose.confidentHabit"/>
              <Paragraph>Q: <Text str="prose.ideaToRememberDrops"/></Paragraph>
              <Paragraph><b> ---- <Text str="prose.lotOwnIdeas"/> ------ </b></Paragraph>
              <Paragraph>R: <Text str="prose.ideaToImproveDrops"/></Paragraph>
              <Paragraph><b>--<Text str="prose.personStruggling"/> ---- </b></Paragraph>
              <Paragraph>Q: <Text str="prose.ideasToAddressBarrier"/></Paragraph>
              <Paragraph str="prose.ideasFromSee"/>
              <Paragraph>o	"<Text str="prose.otherPeopleHelpful"/>"</Paragraph>
              <Paragraph>Q: <Text str="prose.howThoseWorkForYou"/></Paragraph>
              <Paragraph>R: <Text str="prose.mightBeHelpful"/></Paragraph>
              <Paragraph>Q: <Text str="prose.whatMissedToImproveConfidence"/></Paragraph>
              <Paragraph>R: <Text str="prose.feelingConfident"/></Paragraph>
              <Paragraph str="prose.furtherDiscussBarrier"/>
              <Paragraph>Q: <Text str="prose.stepsToPutIntoAction"/></Paragraph>
              <Paragraph>R: <Text str="prose.planIsTo"/></Paragraph>
              <Paragraph><i><Text str="prose.hopeful"/></i></Paragraph>
              <Paragraph>R: <Text str="prose.itSoundsLikeYouAreFeelingHopeful"/></Paragraph>
              <Paragraph><i><Text str="prose.notSoHopeful"/></i></Paragraph>
              <Paragraph>R: <Text str="prose.itSoundsLikeYouAreFeelingNotSoHopeful"/></Paragraph>
              <Paragraph str="prose.sayDontKnow" />
              <Paragraph str="prose.soundsLikeCouldUse" />
            </Fragment>
          }
          {this.scene === 'TWO' &&
            <Fragment>
              <Paragraph><b><center><Text str="prose.sameAdherence"/></center></b></Paragraph>
              <Paragraph><Text str="prose.overView"/>:</Paragraph>
              <Paragraph>* <Text str="prose.warmGreeting"/></Paragraph>
              <Paragraph>* <Text str="prose.shareAdherenceData"/></Paragraph>
              <Paragraph>* <Text str="prose.reflectUntilUnderstanding" /></Paragraph>
              <Paragraph>* <Text str="prose.discussBarriers"/></Paragraph>
              <Paragraph>* <Text str="prose.editPlan"/></Paragraph>
              <Paragraph>* <Text str="prose.summarizeConversation"/></Paragraph>
              <Paragraph>* <Text str="prose.hopefulnessScale"/></Paragraph>
              <Paragraph>   </Paragraph>
              <Paragraph>   </Paragraph>
              <Paragraph>   </Paragraph>
              <br />
              <Paragraph>Q: <Text str="prose.phoneScreeningOpening"/></Paragraph>
              <Paragraph>S: <Text str="prose.phoneNotGoodTime"/></Paragraph>
              <Paragraph>P: <Text str="prose.phoneEyeDropBeforeAfter"/></Paragraph>
              <Paragraph str="prose.beforeXAmount" />
              <Paragraph>(<Text str="prose.amPmDoseComment"/>) </Paragraph>
              <Paragraph>S: <Text str="prose.phoneGoodTime"/></Paragraph>
              <Paragraph>R: <Text str="prose.soundsLikeAbleTo"/></Paragraph>
              <Paragraph>R: <Text str="prose.successImprovement"/></Paragraph>
              <Paragraph>Q: <Text str="prose.yourIdeaToAddressBarriers"/></Paragraph>
              <Paragraph><i> ---- <Text str="prose.lotOwnIdeas" /> ------</i></Paragraph>
              <Paragraph>R: <Text str="prose.ideaToImproveDrops"/></Paragraph>
              <Paragraph><i>--<Text str="prose.personStruggling"/> ---- </i></Paragraph>
              <Paragraph>Q: <Text str="prose.ideasToAddressBarrier"/></Paragraph>
              <Paragraph str="prose.ideasFromSee"/>
              <Paragraph>o	"<Text str="prose.otherPeopleHelpful"/>"</Paragraph>
              <Paragraph>Q: <Text str="prose.howThoseWorkForYou"/></Paragraph>
              <Paragraph>R: <Text str="prose.mightBeHelpful"/></Paragraph>
              <Paragraph>Q: <Text str="prose.whatMissedToImproveConfidence"/></Paragraph>
              <Paragraph>R: <Text str="prose.feelingConfident"/></Paragraph>
              <Paragraph str="prose.furtherDiscussBarrier"/>
              <Paragraph>Q: <Text str="prose.stepsToPutIntoAction"/></Paragraph>
              <Paragraph>R: <Text str="prose.planIsTo"/></Paragraph>
              <Paragraph>R: <Text str="prose.yourFeelingAboutPlan"/></Paragraph>
            </Fragment>
          }
          {this.scene === 'THREE' &&
            <Fragment>
              <Paragraph><b><center><Text str="prose.adherenceImproved"/></center></b></Paragraph>
              <Paragraph><Text str="prose.overView"/>:</Paragraph>
              <Paragraph>* <Text str="prose.warmGreeting"/></Paragraph>
              <Paragraph>* <Text str="prose.shareAdherenceData"/></Paragraph>
              <Paragraph>* <Text str="prose.reflectUntilUnderstanding" /></Paragraph>
              <Paragraph>* <Text str="prose.discussBarriers"/></Paragraph>
              <Paragraph>* <Text str="prose.editPlan"/></Paragraph>
              <Paragraph>* <Text str="prose.summarizeConversation"/></Paragraph>
              <Paragraph>* <Text str="prose.hopefulnessScale"/></Paragraph>
              <Paragraph>   </Paragraph>
              <Paragraph>   </Paragraph>
              <br />
              <Paragraph>Q: <Text str="prose.phoneScreeningOpening"/></Paragraph>
              <Paragraph>S: <Text str="prose.phoneNotGoodTime"/></Paragraph>
              <Paragraph str="prose.phoneShareData" />
              <Paragraph str="prose.phoneEyeDropBeforeAfter" />
              <Paragraph>(<Text str="prose.whatHelpsToSuccess"/>)</Paragraph>
              <Paragraph str="prose.noTrouble"/>
              <Paragraph str="prose.walkThroughDay" />
              <Paragraph str="prose.reflectBackTheySay"/>
              <Paragraph str="prose.greatSystem"/>
              <Paragraph str="prose.endAdherenceNumber" />
              <Paragraph>S: <Text str="prose.phoneGoodTime"/></Paragraph>
              <Paragraph str="prose.reflect" />
              <Paragraph str="prose.implementingPlanGoing" />
              <Paragraph>R: <Text str="prose.soundsLikeAbleTo"/></Paragraph>
              <Paragraph>OR R: <Text str="prose.likeToImprove"/></Paragraph>
              <Paragraph str="prose.motivatedToImprove" />
              <Paragraph str="prose.tryingHard" />
              <Paragraph>R: <Text str="prose.successImprovement"/></Paragraph>
              <Paragraph>Q: <Text str="prose.yourIdeaToAddressBarriers"/></Paragraph>
              <Paragraph> ---- <Text str="prose.lotOwnIdeas"/> ------</Paragraph>
              <Paragraph>R: <Text str="prose.ideaToImproveDrops"/></Paragraph>
              <Paragraph>--<Text str="prose.personStruggling"/> ----</Paragraph>
              <Paragraph>Q: <Text str="prose.ideasToAddressBarrier"/></Paragraph>
              <Paragraph str="prose.ideasFromSee"/>
              <Paragraph>o	"<Text str="prose.otherPeopleHelpful"/>"</Paragraph>
              <Paragraph>Q: <Text str="prose.howThoseWorkForYou"/></Paragraph>
              <Paragraph>R: <Text str="prose.mightBeHelpful"/></Paragraph>
              <Paragraph>Q: <Text str="prose.whatMissedToImproveConfidence"/></Paragraph>
              <Paragraph>R: <Text str="prose.feelingConfident"/></Paragraph>
              <Paragraph str="prose.furtherDiscussBarrier"/>
              <Paragraph>Q: <Text str="prose.stepsToPutIntoAction"/></Paragraph>
              <Paragraph>R: <Text str="prose.planIsTo"/></Paragraph>
              <Paragraph><Text str="prose.hopeful"/></Paragraph>
              <Paragraph>R: <Text str="prose.itSoundsLikeYouAreFeelingHopeful"/></Paragraph>
              <Paragraph><Text str="prose.notSoHopeful"/></Paragraph>
              <Paragraph>R: <Text str="prose.itSoundsLikeYouAreFeelingNotSoHopeful"/></Paragraph>
              <Paragraph str="prose.sayDontKnow" />
              <Paragraph str="prose.soundsLikeCouldUse" />
            </Fragment>
          }
        </Card.Pad>
      </Card>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PhoneSessionScript.js